import { InjectionToken } from "@angular/core";
import { Integration } from "src/app/backend/models/integration";
import { ConnectIntegrationConnector } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connect-integration.connector";

export const CONNECT_INTEGRATION_CONNECTOR_TOKEN_FN = new InjectionToken<
  (integration: Integration) => ConnectIntegrationConnector
>("installation-id-token");
